module.exports = __webpack_public_path__ + "static/media/1MajalahLabur.5f6ef7a7.JPG";